import React, { Component } from 'react';


interface IProps {

}

interface IState {
 
}

export class OffersListController extends Component<IProps, IState> {

  arrowRef: any;
  datePickerRef: any;

  constructor(props: any) {
    super(props);
    this.arrowRef = React.createRef();
    this.datePickerRef = React.createRef();

  }

  state: IState = {
  

  };
  
 
}
export default OffersListController;